import { Component, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { PassesService } from 'src/app/services/passes.service';

@Component({
  selector: 'app-passes',
  templateUrl: './passes.component.html',
  styleUrls: ['./passes.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PassesComponent {
  passes: any[] = [];
  loadingSpinner: boolean = false;
  passQuantities: number[] = [];

  constructor(
    private passesService: PassesService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.getPasses();
  }

  getPasses() {
    this.loadingSpinner = true;
    this.passesService.getCompanyPasses().subscribe({
      next: (passes) => {
        this.passes = passes;
        this.passQuantities = passes.map(() => 1);
        this.loadingSpinner = false;
      },
      error: () => {
        this.loadingSpinner = false;
      }
    });
  }

  changeQuantity(index: number, delta: number, event: Event) {
    event.stopPropagation();
    this.passQuantities[index] = Math.max(1, (this.passQuantities[index] || 1) + delta);
  }

  selectPass(pass: any, index: number) {
    const qty = this.passQuantities[index] || 1;
    if (pass.single_seat) {
      // Butaca única: las `qty` butacas se eligen en el mismo mapa, no hay venta evento a evento
      this.router.navigate(['/pass-sale', pass.id], { queryParams: { quantity: qty } });
    } else if (qty > 1) {
      this.router.navigate(['/pass-sale-bulk', pass.id, qty]);
    } else {
      this.router.navigate(['/pass-sale', pass.id]);
    }
  }

  goBack() {
    this.router.navigate(['/home']);
  }
}
